import { render, staticRenderFns } from "./WirerotorrRubberPendant.vue?vue&type=template&id=1a2df5cf&scoped=true&"
import script from "./WirerotorrRubberPendant.vue?vue&type=script&lang=js&"
export * from "./WirerotorrRubberPendant.vue?vue&type=script&lang=js&"
import style0 from "./WirerotorrRubberPendant.vue?vue&type=style&index=0&id=1a2df5cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2df5cf",
  null
  
)

component.options.__file = "WirerotorrRubberPendant.vue"
export default component.exports